import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Card, CardContent } from "@material-ui/core";
import SearchHeader from "./view/_search-header";
import SearchContent from "./view/_search-content";
import { useSelector } from "react-redux";
import axios from "axios";
import { getContentData } from "./model/service";
import { config } from "../../../../enviroment";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  cardHeight: {
    height: "84vh !important",
    overflow: "overlay",
  },
}));

export default function Search(props) {
  const classes = useStyles();
  const [keyword, setkeyword] = useState();
  useEffect(() => {
    if (props?.location?.state?.word) {
      setkeyword(props?.location?.state?.word);
    }
  }, [props?.location?.state?.word]);
  const [searchResult, setSearchResult] = useState();
  const [sloading, setsLoading] = useState(true);
  const [searchContent, setSearchContent] = useState();

  let language = useSelector(
    (state) =>
      state?.parametersWidgets?.ParameterLookup?.TENANT_PRIMARY_LANGUAGE
  );
    const {t:contents ,  ready: contentReady} = useTranslation("content-E_SEARCH_RESULTS")
   
  useEffect(() => {
    setSearchResult();
    if (keyword) {
      // let finalWord = keyword.toLowerCase().startsWith("faq")
      //   ? "E_faq"
      //   : keyword.toLowerCase().startsWith("userguide")
      //   ? "E_USER_GUIDES"
      //   : keyword;
      setsLoading(true);
      axios
        .post(config.urls.SEARCH, {
          keyWord:keyword,
          indexName:"adss_database"
        })
        .then((res) => {
          setsLoading(false);
          setSearchResult(res.data);
        })
        .catch((error) => {
          setsLoading(false);
        });
    }
  }, [keyword]);

  return (
    <Card className={classes.cardHeight}>
      <CardContent>
        <SearchHeader keyword={keyword} searchContent={contents} contentReady={contentReady} />
        <SearchContent
          sloading={sloading}
          searchResult={searchResult}
          searchContent={contents}
          contentReady={contentReady}
          
        />
      </CardContent>
    </Card>
  );
}
